






































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

interface UserItem {
  title: string;
  icon: string;
  route: string | null;
  action:string | null;
}

@Component
export default class AppHeader extends Vue {
  @Action("toggleNavigationBar", { namespace: "app" }) toggleNavigationBar: any;
  @Action("logout", { namespace: "auth" }) logout: any;
  @Getter("username", { namespace: "auth" }) username: any;

  userItems: UserItem[] = [
    {
      title: "About",
      icon: "mdi-information",
      route: "/about",
      action: null
    },
    {
      title: "Logout",
      icon: "mdi-exit-to-app",
      route: null,
      action: "logout"
    },
  ];

  drawer = true;
  mounted() {}

  toggleNavigation() {
    var userSettng = localStorage.getItem("asea.user.showNav");
    if (userSettng === "true")
      localStorage.setItem("asea.user.showNav", "false");
    else localStorage.setItem("asea.user.showNav", "true");

    this.toggleNavigationBar();
  }
  actionClick(action: string) {
    if (action == "logout") {
      this.logout();
      localStorage.clear();
    }
  }
}
